var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qingliu"},[(_vm.infoflag)?_c('div',{staticClass:"cf"},[_vm._v("bitrate:"+_vm._s(_vm.raw_msg ? _vm.raw_msg/1000 : "0")+"kbps")]):_vm._e(),_c('div',{ref:"player_area"})])}
var staticRenderFns = []

export { render, staticRenderFns }